export default __webpack_public_path__ + "static/media/mainPic.a23c251e.svg";